export default "__VITE_ASSET__e7932a8f__"